import React from "react";
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from "react-router-dom";
import { CommonLayout } from "components/CommonLayout";
import { ReactComponent as DashboardIcon } from "assets/img/dashboard-icon.svg";
import { ReactComponent as BookingIcon } from "assets/img/bookings-icon.svg";
import { ReactComponent as BookingCsvIcon } from "assets/img/bookings-csv-icon.svg";
import { ReactComponent as DriversIcon } from "assets/img/drivers-icon.svg";
import { ReactComponent as FleetManagerIcon } from "assets/img/fleet-management-icon.svg";
import { ReactComponent as SettingsIcon } from "assets/img/settings-icon.svg";
import MonitorHeartIcon from "@mui/icons-material/MonitorHeart";
import { SystemHealthPage } from "pages/SystemHealthPage";
import { DriversPage } from "pages/DriversPage";
import { CompliancePage } from "pages/CompliancePage";
import { DriverCompliancePage } from "pages/DriverCompliancePage";
import { OnboardingPipelinePage } from "pages/OnboardingPipelinePage";
import { RenewalCalendarPage } from "pages/RenewalCalendarPage";
import { AllDriversCompliancePage } from "pages/AllDriversCompliancePage";
import { PendingDocumentsPage } from "pages/PendingDocumentsPage";
import { OrgActivityPage } from "pages/OrgActivityPage";
import { VehicleCompliancePage } from "pages/VehicleCompliancePage";
import { TenantBrandingPage } from "pages/TenantBrandingPage";
import { BrokersPage } from "pages/BrokersPage";
import { BrokerContractsPage } from "pages/BrokerContractsPage";
import { BrokerCompliancePage } from "pages/BrokerCompliancePage";
import { DispatchPage } from "pages/DispatchPage";
import { NeedsAttentionPage } from "pages/NeedsAttentionPage";
import { ComplianceOverviewPage } from "pages/ComplianceOverviewPage";
import { AdminAuditLogPage } from "pages/AdminAuditLogPage";
import { BrokerWebhookPage } from "pages/BrokerWebhookPage";
import { OutboxAdminPage } from "pages/OutboxAdminPage";
import { FleetPage } from "pages/FleetPage";
import { BookingsPage } from "pages/BookingsPage";
import { CreateBookingPage } from "pages/CreateBookingPage";
import { DashboardPage } from "pages/DashboardPage";
import { TenantDashboardPage } from "pages/TenantDashboardPage";
import { BillingPage } from "pages/BillingPage";
import { BillingSuccessPage } from "pages/BillingSuccessPage";
import { BillingCancelPage } from "pages/BillingCancelPage";
import { DispatcherSettings } from "pages/DispatcherSettings";
import { RideChatPage } from "pages/RideChatPage";
import { UnderConstruction } from "pages/UnderConstruction";
import { DriverChatPage } from "pages/DriverChatPage";
import { ClientUserChatPage } from "pages/ClientUserChatPage";
import { RequestFilesPage } from "pages/RequestFilesPage";
import { ImportCsvFilePage } from "pages/ImportCsvFilePage";
import { RequestItemsPage } from "pages/RequestItemsPage";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <CommonLayout
        menu={[
          {
            icon: <DashboardIcon />,
            label: "Dashboard",
            path: "/",
          },
          {
            icon: <BookingIcon />,
            label: "Booking",
            path: "/booking",
          },
          {
            icon: <BookingCsvIcon />,
            label: "Request-Files",
            path: "/request_files",
          },
          {
            icon: <DriversIcon />,
            label: "Drivers",
            path: "/drivers",
          },
          {
            icon: <DashboardIcon />,
            label: "Compliance",
            path: "/compliance",
          },
          {
            icon: <DashboardIcon />,
            label: "Brokers",
            path: "/brokers",
          },
          {
            icon: <DashboardIcon />,
            label: "Contracts",
            path: "/broker-contracts",
          },
          {
            icon: <DashboardIcon />,
            label: "Dispatch",
            path: "/dispatch",
          },
          {
            icon: <FleetManagerIcon />,
            label: "Fleet Management",
            path: "/fleet_management",
          },
          {
            icon: <MonitorHeartIcon />,
            label: "System Health",
            path: "/admin/system-health",
          },
          {
            icon: <SettingsIcon />,
            label: "Settings",
            path: "/settings",
          },
        ]}
      />
    ),
    children: [
      {
        path: "/",
        element: <DashboardPage />,
      },
      {
        path: "/dashboard",
        element: <TenantDashboardPage />,
      },
      {
        path: "/compliance",
        element: <CompliancePage />,
      },
      {
        path: "/compliance/overview",
        element: <ComplianceOverviewPage />,
      },
      {
        path: "/audit-log",
        element: <AdminAuditLogPage />,
      },
      {
        path: "/admin/outbox",
        element: <OutboxAdminPage />,
      },
      {
        path: "/compliance/pipeline",
        element: <OnboardingPipelinePage />,
      },
      {
        path: "/compliance/renewals",
        element: <RenewalCalendarPage />,
      },
      {
        path: "/compliance/drivers",
        element: <AllDriversCompliancePage />,
      },
      {
        path: "/compliance/pending-documents",
        element: <PendingDocumentsPage />,
      },
      {
        path: "/compliance/activity",
        element: <OrgActivityPage />,
      },
      {
        path: "/compliance/vehicles",
        element: <VehicleCompliancePage />,
      },
      {
        path: "/settings/branding",
        element: <TenantBrandingPage />,
      },
      {
        path: "/brokers",
        element: <BrokersPage />,
      },
      {
        path: "/brokers/:brokerId/compliance",
        element: <BrokerCompliancePage />,
      },
      {
        path: "/brokers/:brokerId/webhook",
        element: <BrokerWebhookPage />,
      },
      {
        path: "/broker-contracts",
        element: <BrokerContractsPage />,
      },
      {
        path: "/dispatch",
        element: <DispatchPage />,
      },
      {
        path: "/dispatch/needs-attention",
        element: <NeedsAttentionPage />,
      },
      {
        path: "/compliance/drivers/:driverId",
        element: <DriverCompliancePage />,
      },
      {
        path: "/billing",
        element: <BillingPage />,
      },
      {
        path: "/billing/success",
        element: <BillingSuccessPage />,
      },
      {
        path: "/billing/cancel",
        element: <BillingCancelPage />,
      },
      {
        path: "/booking",
        element: <BookingsPage />,
      },
      {
        path: "/booking/schedule_a_ride",
        element: <CreateBookingPage />,
      },
      {
        path: "/request_files",
        element: <RequestFilesPage />,
      },
      {
        path: "/request_files/:id",
        element: <RequestItemsPage />,
      },
      {
        path: "/import_csv_file",
        element: <ImportCsvFilePage />,
      },
      {
        path: "/drivers",
        element: <DriversPage />,
      },
      {
        path: "/fleet_management",
        element: <FleetPage />,
      },
      {
        path: "/ride_chat/:id",
        element: <RideChatPage />,
      },
      {
        path: "/driver_chat/:id/:chatId",
        element: <DriverChatPage />,
      },
      {
        path: "/client_chat/:id/:chatId",
        element: <ClientUserChatPage />,
      },
      {
        path: "/client_chat/:id",
        element: <UnderConstruction componentName={"Driver Chat"} />,
      },
      {
        path: "/settings",
        element: <DispatcherSettings />,
      },
      {
        path: "/admin/system-health",
        element: <SystemHealthPage />,
      },
      {
        path: "*",
        element: <Navigate to={"/"} replace={true} />,
      },
    ],
  },
]);

const KericoManager = () => <RouterProvider router={router} />;

export default KericoManager;
